import { DishFirstModal, DishFirstModalBody } from 'src/pages/consumer/dish-first/DishFirstModal';
import { minScreen } from 'src/shared/utils/StyledComponentUtils';
import styled from 'styled-components';
import { Colors, FontSize, FontWeight, ScreenWidth, Spacing } from 'web-common/src/shared/styles';
import { NumItems } from '../shared/styles';

export const Header = styled.p`
  border-bottom: 1px solid ${Colors.GRAY_LITE_20};
  font-size: ${FontSize.L};
  font-weight: ${FontWeight.BOLD};
  margin: 0;
  padding: 0 ${Spacing.SINGLE} ${Spacing.SINGLE};

  ${minScreen(ScreenWidth.SMALL)} {
    padding: 0 ${Spacing.SINGLE_HALF} ${Spacing.SINGLE};
  }
`;

export const AdditionalDishesNumber = styled(NumItems)`
  padding: 0 ${Spacing.SINGLE};

  ${minScreen(ScreenWidth.SMALL)} {
    padding: 0 ${Spacing.SINGLE_HALF};
  }
`;

export const StyledRateRecentGroupOrderModal = styled(DishFirstModal)`
  ${minScreen(ScreenWidth.SMALL)} {
    position: absolute;
    right: ${Spacing.SINGLE_HALF};
    bottom: ${Spacing.SINGLE_HALF};
  }
`;

export const RateRecentGroupOrderModalBody = styled(DishFirstModalBody)`
  padding-bottom: ${Spacing.SINGLE};

  ${minScreen(ScreenWidth.SMALL)} {
    padding-bottom: ${Spacing.SINGLE_HALF};
  }
`;
